import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LinkToSite = () => {
    const { t } = useTranslation();
    const url = t('BackToSiteUrl');
    const title = t('BackToSiteTitle');

    return (
        <div className="company-bar-div navigation-div">
            <NavLink
                to={url}
                target="_blank"
                rel="noopener noreferrer"
            >
                <span className="nav-link-with-icon">
                    {title}
                </span>
            </NavLink>
        </div>
    );
};

export default LinkToSite;
